import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Import Pages
import Login from "./pages/Login";
import Create from "./pages/Create";
import Admin from "./pages/Admin/Admin1";
import Service from "./pages/Admin/Service";
import Settings from "./pages/Admin/Settings";
import Stats from "./pages/Admin/Stats";
import UserManagement from "./pages/Admin/UserManagement";
import Forgot from "./pages/Forgot/Forgot";
import User from "./pages/User/User1";
import Payment from "./pages/User/Payment";
import Customer from "./pages/User/Customer"; 
import Profile from "./pages/User/Profile"; 
import Chat from "./pages/Admin/Chat";
import Activity from "./pages/User/Activity";
import AdminSettings from "./pages/Admin/AdminSettings";
import Coinbox from "./pages/Admin/Coinbox";
import AdminProfile from "./pages/Admin/adminprofile";
const NotFound = () => (
  <div style={styles.notFound}>
    <h2>404 - Page Not Found</h2>
    <p>The page you're looking for doesn't exist.</p>
  </div>
);

const App = () => {
  return (
    
    <Router>
      <Routes>
        {/* Redirect root to /login */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/create" element={<Create />} />

        {/* Public Route: Login */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />

        {/* Protected Route: Admin */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/services" element={<Service />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/coinbox" element={<Coinbox/>}/>
        <Route path="/adminsettings" element={<AdminSettings />} />
        <Route path="/adminprofile" element={<AdminProfile />} />
        {/* Protected Route: Admin */}
        <Route path="/usermanagement" element={<UserManagement />} />

        {/* Protected Route: User */}
        <Route path="/activity" element={<Activity />} />
        <Route path="/user" element={<User />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/profile" element={<Profile />} />
        {/* Catch-all Route: 404 Not Found */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

const styles = {
  notFound: {
    textAlign: "center",
    marginTop: "100px",
  },
};

export default App;
